import { Space, SpaceVertical } from '@looker/components';
import { BIButton, BIIcon } from '@pulsepointinc/bi-components';
import { DsTypography } from '@pulsepointinc/design-system-react';
import { type FC, useState } from 'react';
import { ExpandableNotificationContainer, ScrollableList } from '../style';

interface BulkUploadFeedbackProps {
  title: string;
  items?: string[];
  onDismiss?: () => void;
}

export const BulkUploadFeedback: FC<BulkUploadFeedbackProps> = ({ title, items = [], onDismiss }) => {
  const [showInvalid, setShowInvalid] = useState(false);

  if (!title && !items.length) return null;

  return (
    <ExpandableNotificationContainer>
      <Space padding="u2" between align="start">
        <Space gap="u2" align="start">
          <BIIcon icon="Info" style={{ flexShrink: 0, marginTop: '2px' }} />
          <DsTypography variant="label" color="inherit">
            {title}
          </DsTypography>
        </Space>

        <Space width="unset" gap="u2">
          {items.length > 0 && (
            <BIButton color="link" style={{ color: 'inherit' }} onClick={() => setShowInvalid(!showInvalid)}>
              {showInvalid ? 'Collapse' : 'Show Entries'}
            </BIButton>
          )}

          {onDismiss && (
            <BIButton color="link" style={{ color: 'inherit' }} onClick={onDismiss}>
              Ok
            </BIButton>
          )}
        </Space>
      </Space>

      {showInvalid && items.length > 0 && (
        <ScrollableList>
          <SpaceVertical gap="u05">
            {items.map((item, index) => (
              <DsTypography key={`${item}-${index}`} display="inline" variant="caption" color="inherit">
                {item}
              </DsTypography>
            ))}
          </SpaceVertical>
        </ScrollableList>
      )}
    </ExpandableNotificationContainer>
  );
};
